import React from "react";
import Fade from "react-reveal/Fade";
import Slide from "react-reveal/Slide";
import { Parallax } from "react-parallax";
// components
import Mynavbar from "./components/my-navbar/Mynavbar";
import MyCarousel from "./components/carousel/MyCarousel";
import TitleMessage from "./components/title-message/TitleMessage";
import About from "./pages/about/About";
import { Container } from "react-bootstrap";
import Skills from "./pages/skills/Skills";
import Experience from "./pages/experience/Experience";
import ProjectTimeline from "./components/projects-timeline/ProjectTimeline";
import Contact from "./pages/contact-form/Contact";
import Footer from "./components/footer/Footer";
import Particles from "react-particles-js";
import { particlesOptions } from "./particlesOptions";
import "./App.css";

const App = () => {
  return (
    <div className="App" style={{ position: "relative" }}>
      <Mynavbar />
      <MyCarousel />
      <TitleMessage />
      <Particles
        className="particles particles-box"
        params={particlesOptions}
      />
      {/* about me section */}
      <div>
        <Parallax
          blur={{ min: -30, max: 30 }}
          bgImage={require("./assets/img/parallex/background.webp")}
          bgImageAlt=""
          strength={-200}
        >
          <Container className="container-box rounded">
            <Fade duration={500}>
              <About />
            </Fade>
          </Container>
        </Parallax>
      </div>
      {/* Skills section */}
      <Container className="container-box rounded">
        <Slide bottom duration={500}>
          <hr />
          <Skills />
        </Slide>
      </Container>
      {/* Experience section */}
      <div>
        <Container className="container-box rounded">
          <Fade duration={500}>
            <hr />
            <Experience />
          </Fade>
        </Container>
      </div>
      {/* Project Timeline */}
      <div>
        <Container className="container-box rounded">
          <Slide bottom duration={500}>
            <hr />
            <ProjectTimeline />
          </Slide>
        </Container>
      </div>
      {/* Contact */}
      <div>
        <Container className="container-box rounded">
          <Fade duration={500}>
            <hr />
            <Contact />
          </Fade>
        </Container>
      </div>

      <hr />
      <Footer />
    </div>
  );
};

export default App;
